<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="card p-3">
      <div class="card-body">
        <h2 class="card-title-desc">Add New Product</h2>
        <product-form-component button_text="Add Product" @productAction="productAction"/>
      </div>
    </div>
  </Layout>
</template>

<script>
import appConfig from "@/app.config.json";
import Layout from "@/router/layouts/main"
import PageHeader from "@/components/page-header";
import ProductFormComponent from "@/components/products/product-form-component";
import {mapActions} from "vuex";
import {successToast} from "@/components/successToast";
import {routeItems} from "@/router/endpoints";

export default {
  page: {
    title: "Add Product",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {ProductFormComponent, PageHeader, Layout},
  name: "add-product",
  data() {
    return {
      title: "Add Product",
      items: [
        {
          text: "Dashboard",
          href: "/"
        },
        {
          text: "Add Product",
          active: true
        }
      ],
    }
  },

  methods: {
    ... mapActions({
      addProductFn: 'stock/addNewProduct',
    }),
    async productAction(data){
      await this.addProductFn(data).then(resp => {
        if(resp.publicId){
          successToast(`New Product ${resp.productName} added successfully`)
          this.$router.push(routeItems.single_product_route+'/'+resp.publicId)
        }
      })
    },
  }
}
</script>

<style scoped>

</style>
